<template>
  <div class="root-block-msg">
    <div class="flag-wrap">
      <img class="flag" :src="require('../../../../public/img/' + imgId)" alt="">
    </div>
    <div class="text-wrap">
      <div class="title-wrap">
        <span class="text text-title">{{ title }}</span>
      </div>
      <div class="msg-wrap">
        <span class="text text-msg">{{ msg }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imgId: String,
    title: String,
    msg: String
  }
}
</script>

<style lang="stylus" scoped>
@import "BlockMsg.styl"
</style>
